// Centralized image references so Storm-provided photography can be swapped
// across the entire site from one place.
const KIDS_PHOTO =
  'https://cdn.magicpatterns.com/uploads/9FdzrooRa3soLjRegJFGqw/Generated_image_8.png'
const SELF_DEFENSE_PHOTO =
  'https://cdn.magicpatterns.com/uploads/7t63SgLU5wE6RGyTstzYPF/Selfdefence.jpg'
const ADULT_PHOTO =
  'https://cdn.magicpatterns.com/uploads/koCbC3dWW4Y1UXWCZRdjMj/Generated_image_6.png'
const COMPETITION_PHOTO =
  'https://cdn.magicpatterns.com/uploads/mRdQFZphDc1Bab1s28t5hJ/Comp.jpg'
const FAMILY_PHOTO =
  'https://cdn.magicpatterns.com/uploads/8drb2LMSYhKKY14L3dDvcc/Family.jpg'
const SUMMER_CAMP_PHOTO =
  'https://cdn.magicpatterns.com/uploads/cJ4Akz7zzhScbETgZc9vhS/FUn.jpg'
const HOMEPAGE_HERO_PHOTO =
  'https://cdn.magicpatterns.com/uploads/dD21xCDbbk4sRLpoKMbWtv/StormSportTaekwondo-Home-Hero.png'

export const SITE_IMAGES = {
  /** 01 — Homepage hero. */
  heroHome: HOMEPAGE_HERO_PHOTO,
  /** 02 — Mini Troopers (ages 3-5). Stopgap: kids action photo. */
  miniTroopers: KIDS_PHOTO,
  /** 03 — Kids Taekwondo / Storm Troopers (ages 6+). */
  kidsClasses: KIDS_PHOTO,
  /** 04 — Adult Taekwondo. Stopgap: adult self-defense drill photo. */
  adultClasses: ADULT_PHOTO,
  /** 05 — Family Martial Arts. */
  familyClasses: FAMILY_PHOTO,
  /** 06 — Self-Defense. */
  selfDefense: SELF_DEFENSE_PHOTO,
  /** 07 — Competition Team. */
  competitionTeam: COMPETITION_PHOTO,
  /** 08 — Summer Camp. */
  summerCamp: SUMMER_CAMP_PHOTO,
  /** 09 — Parent Trust / Student Confidence. */
  parentTrust: FAMILY_PHOTO,
} as const
